
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[taxonomy]",
      function () {
        return require("private-next-pages/search/[taxonomy]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[taxonomy]"])
      });
    }
  